import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as PatientStore from '../../../app/store/PatientStore';
import LoadPatientProgram from './LoadPatientProgram';

class LoadStudent extends React.Component {
    componentDidMount() {
        if (this.props.match.params.studentId && !this.props.studentData) {
            this.props.getStudentData(this.props.match.params.studentId);
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.match.params.studentId !== this.props.match.params.studentId)
         && (!this.props.studentData || this.props.studentData.id !== this.props.match.params.studentId)) {
            this.props.getStudentData(this.props.match.params.studentId);
        }
    }

    render() {
        const {
            studentData,
        } = this.props;

        if (!studentData) {
            return null;
        }
        return (
            <LoadPatientProgram patientId={studentData.id} patientProgramId={studentData.programData?.id} />
        );
    }
}

LoadStudent.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            studentId: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    getStudentData: PropTypes.func.isRequired,
    studentData: PropTypes.object,
};

LoadStudent.defaultProps = {
    studentData: null,
};

const mapStateToProps = (state, ownProps) => {
    const studentData = state.patient.details && state.patient.details[ownProps.match.params.studentId];
    return {
        studentData,
    };
};

const mapDispatchToProps = dispatch => ({
    getStudentData: bindActionCreators(PatientStore.actionCreators, dispatch).getElement,
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadStudent);
